import { Route, Switch } from "react-router-dom";
import NotFound from "../pages/404";
import Building from "../pages/Building";
import Gallery from "../pages/Gallery";
import GalleryGrid from "../pages/Gallery/GalleryGrid";
import Games from "../pages/Games";
import DinoMath from "../pages/Games/DinoMath";
import Home from "../pages/Home";
import RedirectLogin from "../pages/RedirectLogin";

export default function Routes() {
	return (
		<Switch>
			<Route exact path="/">
				<Home />
			</Route>
			<Route exact path="/jogos">
				<Games />
			</Route>
			<Route path="/jogos/matematica-dino">
				<DinoMath />
			</Route>
			<Route exact path="/galeria">
				<Gallery />
			</Route>
			<Route path="/galeria/:id">
				<GalleryGrid />
			</Route>
			<Route path="/galeria/:id/:slug">
				<GalleryGrid />
			</Route>
			<Route exact path="/redirect">
				<RedirectLogin />
			</Route>
			<Route exact path="/construindo">
				<Building />
			</Route>
			<Route path="/:not">
				<NotFound />
			</Route>
			<Route path="/foto-nao-encontrada">
				<NotFound />
			</Route>
		</Switch>
	);
}
